import fetch from 'isomorphic-fetch';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { from, ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import introspectionQueryResultData from '../fragmentTypes.json';

const tokensToHeaders = tokens =>
  tokens && {
    headers: {
      Authorization: `Bearer ${tokens.accessToken}`
    }
  };

export function initApolloClient(application) {
  const authMiddleware = setContext(() =>
    application.authorization
      .getTokens()
      .then(tokensToHeaders)
      .catch(e => console.log(e.message))
  );

  const logMiddleware = new ApolloLink((operation, forward) => {
    operation.query.definitions.map(
      definition =>
        definition.kind === 'OperationDefinition' &&
        definition.name &&
        console.log(`Gql operation:`, definition.name.value)
    );

    return forward(operation);
  });

  const localeMiddleware = setContext((operation, prevContext) => ({
    ...prevContext,
    headers: {
      ...(prevContext.headers || {}),
      'Accept-Language': application.i18n.language
    }
  }));

  const httpLink = createHttpLink({
    uri: application.settings.get('utcomGateway').url,
    credentials: 'same-origin',
    fetch
  });

  const fragmentMatcher = new IntrospectionFragmentMatcher({ introspectionQueryResultData });

  const cache = new InMemoryCache({ fragmentMatcher });

  const apolloClient = new ApolloClient({
    link: from([logMiddleware, authMiddleware, localeMiddleware, httpLink]),
    cache,
    connectToDevTools: true
  });

  return apolloClient;
}



// WEBPACK FOOTER //
// ./src/services/apolloClient.js